import signblack from "../Assets/images/sblack/signblack.svg";
import signwhite from "../Assets/images/swhite/signwhite.svg";

import customerblack from "../Assets/images/sblack/customerblack.svg";
import customerwhite from "../Assets/images/swhite/customerwhite.svg";

import msgblack from "../Assets/images/sblack/msgblack.svg";
import msgwhite from "../Assets/images/swhite/msgwhite.svg";

import favorateblack from "../Assets/images/sblack/faverateblack.svg";
import favoratewhite from "../Assets/images/swhite/faveratewhite.svg";

import walletblack from "../Assets/images/sblack/walletblack.svg";
import walletwhite from "../Assets/images/swhite/walletwhite.svg";

import girlblack from "../Assets/images/sblack/girlblack.svg";
import girlwhite from "../Assets/images/swhite/girlwhite.svg";

import arrowblack from "../Assets/images/rightarrow.svg";
import arrowwhite from "../Assets/images/rightarrow_hover.svg";

import signoutblack from "../Assets/images/sblack/signoutblack.svg";
import signoutwhite from "../Assets/images/swhite/signoutwhite.svg";

import binblack from "../Assets/images/sblack/binblack.svg";
import binwhite from "../Assets/images/swhite/binwhite.svg";

import boardblack from "../Assets/images/boardblack.svg";
import boardwhite from "../Assets/images/boardwhite.svg";

import libraryBlack from "../Assets/images/lib.png"
import libraryWhite from "../Assets/images/libwhite.png"

import leftarrow from "../Assets/images/left_arrow.svg";
import subblack from "../Assets/images/subblack.svg";
import subwhite from "../Assets/images/subwhite.svg";
import terms from "../Assets/images/terms-and-conditions.svg";
import privacy from "../Assets/images/privacy-policy.svg";

import middleline from "../Assets/images/Line 18.svg";
import enquiryicon from "../Assets/images/QuestionMark.png";
import bellicon from "../Assets/images/bellicon.svg";
import bellicon1 from "../Assets/images/bellicon1.svg";
import wallet from "../Assets/images/wallet.svg";

import eyeclose from "../Assets/images/eye_icon.png";
import eyeopen from "../Assets/images/eyeopen.svg";
import wavesimage from "../Assets/images/waves.png";


// import AppIcons from "../Assets/images/AppIconn.svg";
import AppIcons from "../Assets/images/icon_large (2).png"
import courseimg from "../Assets/images/courses.svg";
import flowImg from "../Assets/images/flowimg.svg";
import HomeImg from "../Assets/images/home.png";
import industryImg from "../Assets/images/industryImg.svg";
import person from "../Assets/images/person.svg";
import tutors from "../Assets/images/tutorsicon.svg";
import NotebookIcon from "../Assets/images/article.png";
import articles from "../Assets/images/articles.svg";






import forwordicon from "../Assets/images/Vector (2).png";
import alltick from "../Assets/images/alltick.svg";
import award from "../Assets/images/award.svg";

import getQualified from "../Assets/images/getQualified.png";
import sorting from "../Assets/images/sort-by.svg";


export default {
    signblack,
    signwhite,
    customerblack,
    customerwhite,
    msgblack,
    msgwhite,
    favorateblack,
    favoratewhite,
    walletblack,
    walletwhite,
    girlblack,
    girlwhite,
    arrowblack,
    arrowwhite,
    signoutblack,
    signoutwhite,
    binblack,
    binwhite,
    boardblack,
    boardwhite,
    leftarrow,
    subblack,
    terms,
    privacy,
    subwhite,
    middleline,
    enquiryicon,
    bellicon,
    bellicon1,
    wallet,
    eyeclose,
    eyeopen,
    wavesimage,
    courseimg,
    person,
    tutors,
    industryImg,
    flowImg,
    HomeImg,
    AppIcons,
    forwordicon,
    alltick,
    award,
    getQualified,
    sorting,
    NotebookIcon,
    articles,
    libraryBlack,
    libraryWhite
};
